module.exports = __webpack_public_path__ + "img/banner04_info_pic3.1bb12502.jpg";